import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { CustomTableReport } from 'src/app/interfaces/custom-table-report/custom-table-report.interface';
import { SubrentalReportFilterModel } from 'src/app/models/subrental/subrental-report-filter.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SubrentalReportService {

  private readonly _httpClient = inject(HttpClient);

  exportSubrentalReportItemPreinvoicedValue(subrentalReportFilterModel: SubrentalReportFilterModel): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.subrentalReport.ExportSubrentalReportItemPreinvoicedValue}`, subrentalReportFilterModel, {
      responseType: 'blob',
    });
  }

  exportSubrentalReportItemUtility(subrentalReportFilterModel: SubrentalReportFilterModel): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.subrentalReport.ExportSubrentalReportItemUtility}`, subrentalReportFilterModel, {
      responseType: 'blob',
    });
  }

  subrentalReportItemPreinvoicedValue(subrentalReportFilterModel: SubrentalReportFilterModel): Observable<CustomTableReport> {
    return this._httpClient.post<CustomTableReport>(`${environment.apiCervinoBackend}${enpointCervinoWeb.subrentalReport.SubrentalReportItemPreinvoicedValue}`, subrentalReportFilterModel);
  }

  subrentalReportItemUtility(subrentalReportFilterModel: SubrentalReportFilterModel): Observable<CustomTableReport> {
    return this._httpClient.post<CustomTableReport>(`${environment.apiCervinoBackend}${enpointCervinoWeb.subrentalReport.SubrentalReportItemUtility}`, subrentalReportFilterModel);
  }

}
